import { IRoutesDefined } from "@/api_framework/api_modals/Routers";

export const APPOINTMENTS_CHECK_SLOTS_SUB_ROUTES: IRoutesDefined = {
  CHECK_AVAILABLE_SLOTS: {
    id: "CHECK_AVAILABLE_SLOTS",
    title: "check_available_slots",
    path: "check-available-slots",
    url: "/app/appointment/check-slots/check-available-slots",
    RBACDisplayName: "CHECK_AVAILABLE_SLOTS_TAB",
    RBACDescription: "Access to check available slots tab view.",
    children: {},
  },
  CHECK_BOOKED_SLOTS: {
    id: "CHECK_BOOKED_SLOTS",
    title: "check_booked_slots",
    path: "check-booked-slots",
    url: "/app/appointment/check-slots/check-booked-slots",
    RBACDisplayName: "CHECK_BOOKED_SLOTS_TAB",
    RBACDescription: "Access to check booked slots tab view.",
    children: {},
  },
};

export const APPOINTMENTS_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  CHECK_SLOTS: {
    id: "CHECK_SLOTS",
    title: "check_slots",
    description: "",
    icon: "",
    RBACDisplayName: "CHECK_SLOTS",
    RBACDescription: "Access to check slots module.",
    url: "/app/appointment/check-slots/check-available-slots",
    path: "check-slots",
    children: {
      ...APPOINTMENTS_CHECK_SLOTS_SUB_ROUTES,
    },
  },
  CHECK_PRICES: {
    id: "CHECK_PRICES",
    title: "check_prices",
    description: "",
    icon: "",
    RBACDisplayName: "CHECK_PRICES",
    RBACDescription: "Access to check prices module.",
    url: "/app/appointment/check-prices",
    path: "check-prices",
    children: {
      ...APPOINTMENTS_CHECK_SLOTS_SUB_ROUTES,
    },
  },
  PREFERRED_DOCTORS: {
    id: "PREFERRED_DOCTORS",
    title: "Preferred Doctors",
    description: "",
    icon: "",
    RBACDisplayName: "PREFERRED_DOCTORS",
    RBACDescription: "Access to clinic preferred doctor mapping.",
    url: "/app/appointment/preferred-doctors",
    path: "preferred-doctors",
    children: {},
  },
  OVERBOOKING: {
    id: "OVERBOOKING",
    title: "Overbooking-list",
    icon: "MdOutlinePersonSearch",
    url: "/app/appointment/overbooking",
    RBACDisplayName: "CREATE_OVERBOOKING",
    RBACDescription: "Access to creation page of overbooking.",
    path: "overbooking",
    children: {},
  },
  OVER_BOOKING_PERMISION_LIST: {
    id: "OVER_BOOKING_PERMISION_LIST",
    title: "Overbooking",
    icon: "AiOutlineUserAdd",
    RBACDisplayName: "OVER_BOOKING_PERMISION_LIST",
    RBACDescription: "Access to overbooking permission list.",
    url: "/app/appointment/over-booking-permision-list",
    path: "over-booking-permision-list",
    children: {},
  },
  HAIRCUT_TO_BATH: {
    id: "HAIRCUT_TO_BATH",
    title: "Use HC as Bath",
    icon: "AiOutlineUserAdd",
    url: "/app/appointment/haircut-to-bath",
    RBACDisplayName: "CONVERT_HAIRCUT_TO_BATH",
    RBACDescription: "Access to convert haircut to bath page and action.",
    path: "haircut-to-bath",
    children: {},
  },
  APPOINTMENT_SHIFT: {
    id: "APPOINTMENT_SHIFT",
    title: "Shift Appointments",
    icon: "AiOutlineUserAdd",
    RBACDisplayName: "SHIFT_APPOINTMENT",
    RBACDescription: "Access to shift appointment page.",
    url: "/app/appointment/shift-appointment",
    path: "shift-appointment",
    children: {},
  },
  OVERBOOKING_V2: {
    id: "OVERBOOKING_V2",
    title: "Initiate Overbooking",
    icon: "MdOutlinePersonSearch",
    url: "/app/appointment/overbooking-v2",
    RBACDisplayName: "INITIATE_OVERBOOKING",
    RBACDescription: "Access to initiate overbooking page.",
    path: "overbooking-v2",
    children: {},
  },
  PRODUCT_REQUIREMENT_FORM: {
    id: "PRODUCT_REQUIREMENT_FORM",
    title: "Product Requirement Form",
    icon: "AiOutlineFileAdd",
    RBACDisplayName: "PRODUCT_REQUIREMENT_FORM",
    RBACDescription: "Access to create product requirement form.",
    url: "/app/appointment/product-requirement-form",
    path: "product-requirement-form",
    children: {},
  },
  CHARGEABLE_BOOKING_LIST: {
    id: "CHARGEABLE_BOOKING_LIST",
    title: "Advance_Payment-bookings-list",
    icon: "AiOutlineUserAdd",
    RBACDisplayName: "CHARGEABLE_BOOKING_LIST",
    RBACDescription: "Access to chargeable booking list",
    url: "/app/appointment/chargeable-bookings-list",
    path: "chargeable-bookings-list",
    children: {},
  },
};

export const ROTA_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  SHIFT_DETAILS: {
    id: "SHIFT_DETAILS",
    title: "shift-details",
    icon: "AiOutlineUser",
    url: "/app/rota/shift-details",
    path: "shift-details",
    children: {},
  },
  SHIFT_ADD: {
    id: "SHIFT_ADD",
    title: "shift-add",
    icon: "AiOutlineUser",
    url: "/app/rota/shift-add",
    path: "shift-add",
    children: {},
  },
  SHIFT_EDIT: {
    id: "SHIFT_EDIT",
    title: "shift-edit",
    icon: "AiOutlineUser",
    url: "/app/rota/shift-edit",
    path: "shift-edit",
    children: {},
  },
  ROTA_VIEW: {
    id: "ROTA_VIEW",
    title: "rota-view",
    icon: "AiOutlineUser",
    url: "/app/rota/rota-view",
    path: "rota-view",
    children: {},
  },
  ROTA_ERROR: {
    id: "ROTA_ERROR",
    title: "rota-error",
    icon: "AiOutlineUser",
    url: "/app/rota/rota-error",
    path: "rota-error",
    children: {},
  },
  REMOVE_SLOTS: {
    id: "REMOVE_SLOTS",
    title: "Remove Slots",
    icon: "AiOutlineUser",
    url: "/app/rota/remove-slots",
    path: "remove-slots",
    RBACDisplayName: "REMOVE_SLOTS",
    RBACDescription: "Access to remove slots page.",
    children: {},
  },
  BOOKING_FEE_CONFIG: {
    id: "BOOKING_FEE_CONFIG",
    title: "Booking Fee Configurations",
    icon: "AiOutlineUser",
    url: "/app/rota/booking-fee",
    path: "booking-fee",
    RBACDisplayName: "BOOKING_FEE_CONFIG",
    RBACDescription: "Access to prepaid booking fee configuration.",
    children: {},
  },
};

